import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlightsSummaryComponent from './FlightsSummaryComponent';

class FlightsSummary extends Component {
  constructor(props) {
    super(props);

    const { summaryType, productToken, exclusive } = props;
    this.summaryKey = { summaryType, /*id: productToken,*/ exclusive };

    this.state = {
      modalOpen: false,
    };

    this.handleOnClickFlightDetails = this.handleOnClickFlightDetails.bind(this);
    this.handleOnClickCloseFlightDetailsModal = this.handleOnClickCloseFlightDetailsModal.bind(this);
  }

  handleOnClickFlightDetails() {
    this.setState({ modalOpen: true });
  }

  handleOnClickCloseFlightDetailsModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const { productToken, flightsCombination, searchToken } = this.props;

    if (!flightsCombination) {
      return null;
    }

    return (
      <FlightsSummaryComponent
        summaryKey={this.summaryKey}
        {...this.state}
        searchToken={searchToken}
        productToken={productToken}
        flights={flightsCombination}
        onClickFlightDetails={this.handleOnClickFlightDetails}
        onClickCloseFlightDetailsModal={this.handleOnClickCloseFlightDetailsModal}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    searchToken: state.checkoutPagePackagesSearch.value && state.checkoutPagePackagesSearch.value.searchToken,
  };
}

export default connect(mapStateToProps)(FlightsSummary);
